module.exports = __webpack_public_path__ + "static/media/restaurant.481f02de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/restaurant.svg
// module id = 945
// module chunks = 5